import { styled } from "@mui/material/styles";
import { AppBar, Box } from "@mui/material";

// Constants
export const DRAWER_WIDTH = 240;

// Styled components
export const StyledAppBar = styled(AppBar)(({ theme }) => ({
  borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
  [theme.breakpoints.down("sm")]: {
    paddingTop: "0.5rem",
    paddingBottom: "0.5rem"
  }
}));

export const NavigationLink = styled(Box)(({ theme }) => ({
  marginLeft: theme.spacing(3),
  marginRight: theme.spacing(3),
  textDecoration: "none",
  display: "flex",
  alignItems: "center",
  color: "inherit",
  "&:hover": {
    color: theme.palette.primary.main
  }
}));

// Here, theme is not used, so we remove it from the parameter list
export const LogoContainer = styled(Box)({
  display: "flex",
  alignItems: "center",
  textDecoration: "none",
  color: "inherit",
  flexGrow: 1
});

export const DrawerContent = styled(Box)({
  width: DRAWER_WIDTH
});
